import React from 'react'

export default function Message({ value, isRight, color, props, style }) {
    return (
        <div style={{ textAlign: isRight ? 'right' : 'left', color: color ? color : 'red', ...props, ...style }}>
            {value}
        </div>
    )
}
